import { defaultEntityState, IEntityState } from '@core/state/entities/entity';
import { mergeEntityState } from '@core/state/entities/entity.helpers';
import { IProjectUsage } from '@core/state/entities/project-usage/project-usage.entity';
import { createReducer, on } from '@ngrx/store';
import { projectDetailActions } from '@core/actions/project-detail.actions';
import { authApiActions } from '@core/auth/auth.actions';
import { entityKey } from '@core/state/entities/entity-name-map';

export const projectUsageReducer = createReducer(
  defaultEntityState<IProjectUsage>(),
  on(
    projectDetailActions.projectFavouriteSet,
    projectDetailActions.stageFavouriteSet,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectUpdated,
    authApiActions.signInRecorded,
    (state, props) => mergeEntityState(entityKey.projectUsages, state, props)
  )
);
